import { BackOfficeDtoConverter } from './backoffice-dto-converter';
import { BackOfficeDataProvider } from './BackOfficeDataProvider.abstract';
import { defaultUrlRenderer } from './default-url-renderer';
import { DtoConverter } from './interfaces/dto-converter.interface';

export class DefaultDataProvider extends BackOfficeDataProvider {
  protected urlRenderer = defaultUrlRenderer;
  protected dtoConverter: DtoConverter = new BackOfficeDtoConverter();
}
